module.exports = __webpack_public_path__ + "static/img/290_TO8_2464.c33d148.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/290_TO8_2464.jpg
// module id = N4cE
// module chunks = 0